import { render, staticRenderFns } from "./Done.vue?vue&type=template&id=464fd518&scoped=true&lang=pug&"
import script from "./Done.vue?vue&type=script&lang=ts&"
export * from "./Done.vue?vue&type=script&lang=ts&"
import style0 from "./Done.vue?vue&type=style&index=0&id=464fd518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464fd518",
  null
  
)

export default component.exports